import React, { useState } from 'react';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  OKIcon,
  OKShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';
import copyIconW from '../../assets/Refer/copy-icon-w.svg';
import shareIcon from '../../assets/Refer/share-icon.svg';

export const BrokerCard = ({ broker }) => {
  const [showShare, setShowShare] = useState(false);

  const copyLink = (broker) => {
    const el = document.createElement('input');
    el.value = broker.link;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    alert('Link Copied');
  };
  return (
    <div
      key={broker.name}
      className=' col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12'
    >
      <div className={`card`}>
        {broker.name === '' ? (
          <>
          <div className='icons selectAnyDemat'>
            <h4 className='selectAnyDematText'>Select Any</h4>
          </div>
          
          <div className='brokerEarning'>
              <p>&nbsp;</p>
              <span>&nbsp; </span>
            </div></>
        
        ) : (
          <>
            <div className='icons'>
              <img src={broker.image} alt={broker.name} className='img' />
            </div>
            <div className='brokerEarning'>
              <p>{'You earn ₹ ' + broker.reward}</p>
              <span>for every successful referral</span>
            </div>
          </>
        )}
        <div className='bluebgrefer'>
          <div
            style={{
              position: 'absolute',
              borderRadius: 4,
              display: 'flex',
              left: 20,
            }}
          >
            {' '}
            <h5>Refer:</h5>
          </div>
          <div
            className='tooltip-icon'
            onClick={() => {
              copyLink(broker);
            }}
          >
            <img src={copyIconW} alt={'copy tooltip'} className='img' />
            <span className='tooltiptext'>Copy</span>
          </div>
          <div
            className='tooltip-icon'
            onClick={() => {
              // shareViaWhatsapp(broker);
              setShowShare(!showShare);
            }}
          >
            <img src={shareIcon} alt={'share tooltip'} className='img' />
            <span className='tooltiptext'>Share</span>
          </div>

          <div
            style={{
              position: 'absolute',
              background: 'white',
              padding: 5,
              borderRadius: 4,
              display: showShare ? 'flex' : 'none',
              right: 5,
            }}
          >
            <div style={{ marginTop: 1 }}>
              <FacebookShareButton
                url={broker.link}
                quote={'Checkout the registration Link'}
              >
                <FacebookIcon
                  size={32}
                  round={true}
                  onClick={() => setShowShare(false)}
                />
              </FacebookShareButton>
            </div>
            <div style={{ marginTop: 1 }}>
              <WhatsappShareButton
                url={broker.link}
                quote={'Checkout the registration Link'}
              >
                <WhatsappIcon
                  size={32}
                  round={true}
                  onClick={() => setShowShare(false)}
                />
              </WhatsappShareButton>
            </div>
            <div style={{ marginTop: 1 }}>
              <EmailShareButton
                subject={`Broker Referal Link`}
                body={`Check out registration Link :`}
                separator={` `}
                url={broker.link}
              >
                <EmailIcon
                  size={32}
                  round={true}
                  onClick={() => setShowShare(false)}
                />
              </EmailShareButton>
            </div>

            <div style={{ marginTop: 1 }}>
              <TwitterShareButton
                url={broker.link}
                quote={'Checkout the registration Link'}
              >
                <TwitterIcon
                  size={32}
                  round={true}
                  onClick={() => setShowShare(false)}
                />
              </TwitterShareButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
